import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { toast } from 'react-toastify';
import { labRequestTests } from '../../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";
import {
  ADD_NEW_LABREQUESTTEST,
  DELETE_LABREQUESTTEST,
  GET_LABREQUESTTESTS,
  UPDATE_LABREQUESTTEST,
  MASSIVE_STATUS_UPDATE
} from "./actionTypes";
import {
  addLabRequestTestFail,
  addLabRequestTestSuccess,
  deleteLabRequestTestFail,
  deleteLabRequestTestSuccess,
  getLabRequestTestsFail,
  getLabRequestTestsSuccess,
  setState,
  updateLabRequestTestFail,
  updateLabRequestTestSuccess,
  massiveStatusUpdateSuccess,
  massiveStatusUpdateFail
} from "./actions";

//Include Both Helper File with needed methods

function* fetchLabRequestTests( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable,labRequestTests, params.toString());
    yield put(setState(false))
    yield put(getLabRequestTestsSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getLabRequestTestsFail(error));
  }
}

function* updateLabRequestTest ({payload: labRequestTestObj }) {
  try {
    const { id, recordStatus, ...rest } = labRequestTestObj;
    yield call(patchApiCall, `${labRequestTests}/${id}`, rest);
    const response = yield call(getTable,`${labRequestTests}/${labRequestTestObj.id}`);
    // console.log('OBJETO actualizado:', response)
    yield put(updateLabRequestTestSuccess(response));
    toast.success('Registro actualizado correctamente')
  } catch (error) {
    yield put(updateLabRequestTestFail(error));
    toast.error('Error al actualizar el registro')
  }
}

function* deleteLabRequestTest ({payload: labRequestTestObj}) {
  try {
    yield call(deleteApiCall, `${labRequestTests}/${labRequestTestObj.id}`);
    yield put(deleteLabRequestTestSuccess(labRequestTestObj.id));
    toast.success('Registro borrado correctamente')
  } catch (error) {
    yield put(deleteLabRequestTestFail(error));
    toast.error('Error al borrar el registro')
  }
}

function* postingLabRequestTest ({ payload: labRequestTest}) {
  try {
    const response = yield call(postApiCall, labRequestTests ,labRequestTest);
    const response2 = yield call(getTable,`${labRequestTests}/${response.id}`);
    yield put(addLabRequestTestSuccess(response2));
    toast.success('Registro agregado correctamente')
  } catch (error) {
    yield put(addLabRequestTestFail(error));
    toast.error('Error al agregar el registro')
  }
}

function* massiveLabRequestTestStatusUpdate({ payload: { labRequestId, statusTest } }) {
  try {
    yield put(setState(true));
    const endpoint = `${labRequestTests}/massive/status-update?labRequest=${labRequestId}&statusTest=${statusTest}`;
    const response = yield call(patchApiCall, endpoint);
    const { updatedCount } = response;
    yield put(massiveStatusUpdateSuccess());
    if (updatedCount === 0) {
      toast.info('No se encontraron ensayos para actualizar');
      return;
    }
    toast.success(`${updatedCount} ensayos actualizados correctamente`);
  } catch (error) {
    yield put(massiveStatusUpdateFail(error));
    toast.error('Error al actualizar el estado de los ensayos');
  } finally {
    yield put(setState(false));
  }
}

function* labRequestTestsSaga() {
  yield takeEvery(GET_LABREQUESTTESTS, fetchLabRequestTests);
  yield takeEvery(ADD_NEW_LABREQUESTTEST, postingLabRequestTest);
  yield takeEvery(UPDATE_LABREQUESTTEST, updateLabRequestTest);
  yield takeEvery(DELETE_LABREQUESTTEST, deleteLabRequestTest);
  yield takeEvery(MASSIVE_STATUS_UPDATE, massiveLabRequestTestStatusUpdate);
}

export default labRequestTestsSaga;
